import axios from 'axios';

function getToken() {
    const tokenString = localStorage.getItem('access_token');
    if (!tokenString) return '';
    return tokenString;
}

const auth = {
    isAuthenticated: () => {
    const authenticated = getToken().length > 0;
    if (!authenticated && window.location.href.indexOf('login') === -1) {
        window.location = '/login-register';
    }
    return authenticated;
},
    authenticate(email, password, cb) {
        axios.post(`${window.location.origin}/api/auth/token`, { UserName: email, Password: password }).then((data) => {
            if (!data.data) {
                return;
            }
            if (data.status !== 200) {
                return;
            }

            localStorage.setItem('access_token', data.data);
            window.location= '/'
        }).catch(
            (error) => {
                return Promise.reject(error);
            },
        );
    },
    authenticateSSO(token, cb) {
        axios.post(`${window.location.origin}/api/sso`, { token }).then((data) => {
            if (!data.data) {
                cb({ success: false });
                return;
            }
            if (data.status !== 200) {
                cb({ success: false });
                return;
            }

            localStorage.setItem('access_token', data.data.access_token);
            cb({ success: true });
        }).catch(
            (error) => {
                cb({ success: false });
                return Promise.reject(error);
            },
        );
    },
    signout(cb) {
        localStorage.removeItem('access_token');
        cb();
    },
};

export default auth;